/**
 * Sports Realm — colourway switcher.
 *
 * Pure state toggling: every value (colour name, price, deep link, badge, index)
 * is rendered server-side by Liquid onto each swatch, so no prices are formatted
 * or product data resolved in JavaScript. Tabs swap which product set is shown.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.srCwReady === 'true') return;

    /* ---- Brand tabs ---- */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sr-cw-tab]'));
    var sets = Array.prototype.slice.call(root.querySelectorAll('[data-sr-cw-set]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.dataset.srCwTab;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('sr-is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        sets.forEach(function (s) {
          var on = s.dataset.srCwSet === i;
          s.hidden = !on;
          s.classList.toggle('sr-is-active', on);
        });
      });
    });

    /* ---- Swatches, scoped to their own set ---- */
    sets.forEach(function (set) {
      var swatches = Array.prototype.slice.call(set.querySelectorAll('[data-sr-cw-swatch]'));
      var images = Array.prototype.slice.call(set.querySelectorAll('[data-sr-cw-image]'));
      var nameEl = set.querySelector('[data-sr-cw-colourname]');
      var priceEl = set.querySelector('[data-sr-cw-price]');
      var ctaEl = set.querySelector('[data-sr-cw-cta]');
      var badgeEl = set.querySelector('[data-sr-cw-badge]');
      var tagEl = set.querySelector('[data-sr-cw-tagno]');

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          var i = sw.dataset.srCwSwatch;
          swatches.forEach(function (s) {
            var on = s === sw;
            s.classList.toggle('sr-is-active', on);
            s.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          images.forEach(function (img) {
            img.classList.toggle('sr-is-active', img.dataset.srCwImage === i);
          });
          if (nameEl) nameEl.textContent = sw.dataset.colourName || '';
          // Only present when the colourways differ in price; leaving the node
          // untouched keeps the currency converter's own output intact.
          if (priceEl && sw.dataset.price) priceEl.innerHTML = sw.dataset.price;
          if (ctaEl && sw.dataset.url) ctaEl.setAttribute('href', sw.dataset.url);
          if (badgeEl) badgeEl.innerHTML = sw.dataset.badge || '';
          if (tagEl) tagEl.textContent = sw.dataset.indexLabel || '';
        });
      });
    });

    root.dataset.srCwReady = 'true';
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-sr-cw]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
